const video =
{
    failed   : 'Impossible d\'ajouter un fichier vidéo',
    remove :
    {
        agree       : 'Supprimer' ,
        description : 'Souhaitez-vous supprimer ce fichier vidéo ?' ,
        disagree    : 'Annuler' ,
        loading     : 'Suppression en cours...' ,
        title       : 'Supprimer la vidéo ?',
        useID       : false
    },
    removed  : 'Vidéo supprimée',
    success  : 'Vidéo ajoutée avec succès',
    title    : 'Vidéo' ,
    tooltips :
    {
        add         : 'Ajouter',
        remove      : 'Supprimer',
        selectMedia : 'Sélectionner'
    }
};

export default video ;